import React from "react";
import classNames from "classnames";
import { IconList } from "@/components/IconList";
import { SocialNetwork } from "@/types/qr";
import "./PreviewSocialNetworks.scss";

export interface PreviewSocialNetworksProps {
  networks?: SocialNetwork[];
  variant?: "business" | "coupon" | "links" | "website" | "mp3";
  className?: string;
  [key: string]: unknown;
}

// Predefined configurations by variant
const VARIANT_CONFIGS = {
  business: {
    center: true,
    compact: false,
  },
  coupon: {
    center: true,
    compact: true,
  },
  links: {
    center: true,
    compact: false,
  },
  website: {
    center: true,
    compact: false,
  },
  mp3: {
    center: true,
    compact: true,
  },
} as const;

/**
 * Wrapper for IconList with predefined configurations by preview context
 * Standardizes the use of social networks in different types of QR codes
 */
export function PreviewSocialNetworks({
  networks,
  variant = "business",
  className,
  ...rest
}: PreviewSocialNetworksProps) {
  if (!networks || networks.length === 0) {
    return null;
  }

  const config = VARIANT_CONFIGS[variant];
  const containerClasses = classNames(
    "preview-social-networks",
    `preview-social-networks--${variant}`,
    className
  );

  return (
    <div className={containerClasses}>
      <IconList
        items={networks}
        {...config}
        {...rest}
      />
    </div>
  );
}
